import classNames from 'classnames/bind';

import styles from './S02.module.scss';

import video from '../../../assets/video/pulmuonewater.mp4';

const cx = classNames.bind(styles);

const S02 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <h2 className={cx('title')}>깊은 자연의 기술, 풀무원샘물</h2>
        <video controls>
          <source src={video} type="video/mp4" />
        </video>
      </div>
    </div>
  );
};

export default S02;
